import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Clock3, Loader2 } from "lucide-react";

const STATUS = {
  demande: { l: "En cours de validation", c: "bg-[#FFDCA8] text-[#92400E]" },
  propose: { l: "Nouveau créneau proposé", c: "bg-[#06B6D4] text-[#0A1128]" },
  confirme: { l: "Confirmé", c: "bg-green-600 text-white" },
  realise: { l: "Réalisé", c: "bg-slate-500 text-white" },
  annule: { l: "Annulé", c: "bg-red-500 text-white" },
};

export default function PublicAppt() {
  const { id } = useParams();
  const [a, setA] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => api.get(`/appointments/${id}/public`).then((r) => setA(r.data)).catch(() => toast.error("RDV introuvable"));
  useEffect(() => { load(); }, [id]);

  const accept = async () => {
    setLoading(true);
    try { await api.post(`/appointments/${id}/accept-proposal`); toast.success("Créneau accepté !"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
    finally { setLoading(false); }
  };

  if (!a) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin" /></div>;

  const st = STATUS[a.status] || { l: a.status, c: "bg-slate-300" };
  return (
    <>
      <Header />
      <main className="pt-36 sm:pt-40 pb-20 min-h-screen bg-[#FAFAFA]">
        <div className="max-w-2xl mx-auto px-4">
          <div className="bg-white border border-black/8 rounded-3xl p-8">
            <div className="text-xs font-bold tracking-[0.3em] uppercase text-[#06B6D4]">Votre rendez-vous</div>
            <h1 className="display text-3xl text-[#0A1128] font-extrabold mt-2">Bonjour {a.name}</h1>
            <div className="mt-3"><span className={`inline-block px-3 py-1 rounded-full text-xs font-bold ${st.c}`}>{st.l}</span></div>

            <div className="mt-6 bg-[#FAFAFA] rounded-xl p-4 border border-black/8">
              <div className="text-xs uppercase tracking-widest text-[#64748B]">Créneau initial</div>
              <div className="display text-lg font-bold text-[#0A1128]">{a.preferred_date || "—"} {a.preferred_time || ""}</div>
            </div>

            {a.status === "propose" && (
              <div className="mt-4 bg-[#06B6D4]/10 border border-[#06B6D4] rounded-xl p-5">
                <div className="text-xs uppercase tracking-widest text-[#06B6D4]">Nouveau créneau proposé</div>
                <div className="display text-2xl font-extrabold text-[#0A1128] mt-1">{a.proposed_date} {a.proposed_time}</div>
                {a.admin_note && <div className="text-sm text-[#475569] mt-2 bg-white rounded-lg p-3 border border-black/8">{a.admin_note}</div>}
                <Button onClick={accept} disabled={loading} data-testid="appt-accept" className="mt-4 w-full bg-[#0A1128] text-white"><CheckCircle2 size={14} className="mr-2" />Accepter ce créneau</Button>
              </div>
            )}

            {a.status === "confirme" && (
              <div className="mt-4 bg-[#A7F3D0]/30 border border-[#A7F3D0] rounded-xl p-5 text-center">
                <CheckCircle2 className="text-green-600 mx-auto" size={36} />
                <div className="display text-xl font-extrabold text-[#0A1128] mt-2">RDV confirmé</div>
                <div className="text-sm text-[#475569] mt-1">À très vite !</div>
              </div>
            )}

            <Link to="/" className="block text-center mt-6 text-xs text-[#06B6D4] hover:underline">← Retour à l'accueil</Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
